/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import { jsx } from '@atlaskit/css';

import { GlobalWrapper } from '../GlobalWrapper/GlobalWrapper';

/**
 * Keeps the global styles required by streaming decorations without mounting any
 * Editor AI session UI.
 */
export const StreamingContentComponent = (): JSX.Element => <GlobalWrapper>{null}</GlobalWrapper>;
